

const footer = () => {

    // ENV
    const version = import.meta.env.VITE_VERSION;

    return (
        <div className="footer">
            v{version}
        </div>
    )
}

export default footer;